module.exports = __webpack_public_path__ + "img/cb_kohteet.0c75aa3a.svg";